/* Old Skool Energy — homepage interactions
   Motion rule: transform/opacity only, all gated by prefers-reduced-motion. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Marquee content (duplicated for seamless loop) ---------- */
  function fill(el, items, tag) {
    if (!el) return;
    var html = items.map(function (t) { return '<' + tag + '>' + t + '</' + tag + '>'; }).join('');
    el.innerHTML = html + html;
  }
  fill(document.getElementById('slang'), [
    'BUILD', 'EARN', 'GRIND', 'PROVE', 'REAL', 'LOYAL', 'GRIT',
    'OUTWORK', 'SHOW UP', 'NO EXCUSES', 'DONE RIGHT', 'THE LONG GAME'
  ], 'b');

  /* ---------- Mobile nav ---------- */
  var hdr = document.getElementById('hdr'), burger = document.getElementById('burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var open = hdr.classList.toggle('ose-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('#nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        hdr.classList.remove('ose-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Scroll reveals ---------- */
  var rv = document.querySelectorAll('.ose-rv');
  if (RM || !('IntersectionObserver' in window)) {
    rv.forEach(function (n) { n.classList.add('ose-in'); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ose-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    rv.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Signature: pinned can worlds ---------- */
  var track = document.getElementById('railTrack');
  var scenes = [].slice.call(document.querySelectorAll('.ose-rail__scene'));
  var cans = [].slice.call(document.querySelectorAll('#railCans img'));
  var names = [].slice.call(document.querySelectorAll('#railNames > div'));
  var num = document.getElementById('railNum');
  var dotWrap = document.getElementById('railDots');
  var ACCENTS = ['#E32402', '#8E9199', '#C4423A'];
  var N = scenes.length, cur = -1;

  if (dotWrap) {
    for (var i = 0; i < N; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Can ' + (i + 1));
      (function (idx) {
        b.addEventListener('click', function () {
          if (!track) return;
          var top = track.getBoundingClientRect().top + window.pageYOffset;
          var h = track.offsetHeight - window.innerHeight;
          window.scrollTo({ top: top + (h * (idx + 0.5) / N), behavior: RM ? 'auto' : 'smooth' });
        });
      })(i);
      dotWrap.appendChild(b);
    }
  }
  var dots = dotWrap ? [].slice.call(dotWrap.children) : [];

  function setFlavor(i) {
    if (i === cur || i < 0 || i >= N) return;
    cur = i;
    scenes.forEach(function (n, k) { n.classList.toggle('ose-on', k === i); });
    cans.forEach(function (n, k) { n.classList.toggle('ose-on', k === i); });
    names.forEach(function (n, k) { n.classList.toggle('ose-on', k === i); });
    dots.forEach(function (n, k) { n.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    if (num) num.textContent = 'CAN ' + ('0' + (i + 1)).slice(-2) + ' / 0' + N;
    document.documentElement.style.setProperty('--accent', ACCENTS[i]);
  }
  setFlavor(0);

  /* ---------- Header + dock + rail scroll loop (rAF-throttled) ---------- */
  var dock = document.getElementById('dock');
  var hero = document.querySelector('.ose-hero');
  var club = document.querySelector('.ose-club');
  var drifts = [].slice.call(document.querySelectorAll('.ose-drift__row'));
  var stage = document.getElementById('stage');
  var specs = [].slice.call(document.querySelectorAll('.ose-stage__spec'));
  var heroCan = document.getElementById('heroCan');
  var ticking = false;

  function onScroll() {
    var y = window.pageYOffset, vh = window.innerHeight;

    /* pinned flavor progress */
    if (track) {
      var tr = track.getBoundingClientRect();
      var h = track.offsetHeight - vh;
      var p = (-tr.top) / (h > 0 ? h : 1);
      if (p >= -0.02 && p <= 1.02) {
        var idx = Math.min(N - 1, Math.max(0, Math.floor(p * N + 0.0001)));
        setFlavor(idx);
      }
    }

    /* sticky buy dock: after hero, hidden over the club + closer */
    if (dock && hero) {
      var past = y > hero.offsetHeight * 0.9;
      var nearEnd = club ? (club.getBoundingClientRect().top < vh - 120) : false;
      dock.classList.toggle('ose-on', past && !nearEnd);
    }

    if (!RM) {
      /* hero parallax depth */
      if (stage && y < vh * 1.3) {
        if (heroCan) heroCan.style.setProperty('--py', (y * -0.05).toFixed(2) + 'px');
        specs.forEach(function (s) {
          var d = parseFloat(s.dataset.depth || 0);
          s.style.transform = 'translate3d(0,' + (y * d / 600).toFixed(2) + 'px,0)';
        });
      }
      /* opposing drift rows */
      drifts.forEach(function (row) {
        var r = row.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var prog = (vh - r.top) / (vh + r.height);
        var dir = parseFloat(row.dataset.dir || 1);
        var amt = (prog - 0.5) * 260 * dir;
        row.style.transform = 'translate3d(' + amt.toFixed(1) + 'px,0,0)';
      });
    }
    ticking = false;
  }
  function req() { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  onScroll();

  /* ---------- Hero pointer parallax ---------- */
  if (!RM && stage && window.matchMedia('(pointer:fine)').matches) {
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var dx = (e.clientX - r.left) / r.width - 0.5;
      if (heroCan) heroCan.style.setProperty('--px', (dx * 16).toFixed(2) + 'px');
    });
    stage.addEventListener('mouseleave', function () {
      if (heroCan) heroCan.style.setProperty('--px', '0px');
    });
  }

  /* ---------- Card 3D tilt ---------- */
  if (!RM && window.matchMedia('(pointer:fine)').matches) {
    document.querySelectorAll('.ose-tilt').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var yy = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (x * 9).toFixed(2) + 'deg) rotateX(' + (-yy * 9).toFixed(2) + 'deg) translateY(-6px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
    /* magnetic CTAs */
    document.querySelectorAll('.mag').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var yy = (e.clientY - r.top) / r.height - 0.5;
        btn.style.transform = 'translate3d(' + (x * 9).toFixed(1) + 'px,' + (yy * 6).toFixed(1) + 'px,0)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Cursor label over the flavor rail ---------- */
  var cursor = document.getElementById('cursor');
  var railPin = document.querySelector('.ose-rail__pin');
  if (!RM && cursor && railPin && window.matchMedia('(pointer:fine)').matches) {
    document.addEventListener('mousemove', function (e) {
      cursor.style.transform = 'translate3d(' + (e.clientX + 16) + 'px,' + (e.clientY + 16) + 'px,0)';
    }, { passive: true });
    railPin.addEventListener('mouseenter', function () { cursor.classList.add('ose-on'); });
    railPin.addEventListener('mouseleave', function () { cursor.classList.remove('ose-on'); });
  }

  /* ---------- Buy box ---------- */
  var opts = [].slice.call(document.querySelectorAll('.ose-buybox__opt'));
  var buyBtn = document.getElementById('buyBtn');
  opts.forEach(function (o) {
    o.addEventListener('click', function () {
      opts.forEach(function (x) { x.classList.remove('ose-sel'); });
      o.classList.add('ose-sel');
      if (buyBtn) buyBtn.innerHTML = 'Add the ' + o.dataset.label + ' — $' + o.dataset.ose-price + ' <span class="ose-arw">→</span>';
    });
  });

  /* ---------- Email capture ---------- */
  var form = document.getElementById('clubForm'), msg = document.getElementById('clubMsg');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type=email]');
      if (!email.value || email.value.indexOf('@') < 0) { email.focus(); return; }
      form.innerHTML = '<p class="ose-d ose-d-sm" style="color:#fff;margin:0">YOU\'RE IN. WE\'LL BE IN TOUCH.</p>';
      if (msg) msg.textContent = 'Demo form — connect this to the store\'s email platform before launch.';
    });
  }
})();
